<template>
  <van-popup
    :value="value"
    round
    position="bottom"
    overlay
    @click-overlay="clickOverlay"
  >
    <div class="pay-by-credits-wrapper">
      <div class="title">
        <span class="label-title">积分余额</span>
        <p class="credits-count">{{ credits.total }}积分</p>
        <span class="create-vip-text">
          积分不够，去赚积分
          <van-icon name="arrow" />
        </span>
      </div>
      <div class="pay-button-wrapper">
        <van-button
          class="credits-button"
          loading-text="解锁中..."
          :loading="payLoading"
          @click="payHandler"
        >消耗{{ creditsNeeded }}积分解锁</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BasisCreditsPopup',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    creditsNeeded: {
      type: null,
      required: true,
      default: 0
    }
  },
  data: () => ({
    payLoading: false
  }),
  computed: {
    ...mapGetters(['credits'])
  },
  methods: {
    clickOverlay () {
      this.$emit('change', false)
      this.$emit('clickOverlay')
    },
    payHandler () {
      this.payLoading = true
      this.$emit('pay', () => {
        this.payLoading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.pay-by-credits-wrapper {
  padding: 16px;
  .title {
    position: relative;
    padding-bottom: 16px;
    .label-title {
      @include sc($font-size-base, $color-text-light);
      @include lw(17px, 500);
    }
    .credits-count {
      @include sc($font-size-md, #F24724);
      @include lw(14px);
      padding-top: 8px;
    }
    .create-vip-text {
      @include sc($font-size-base, #FFA119);
      position: absolute;
      top: 12px;
      right: 0;
      .van-icon {
        vertical-align: middle;
      }
    }
  }
  .pay-button-wrapper {
    .credits-button {
      @include lg-radius(#ECCEA2, #E7B170, 4px);
      @include normal-button(100%, 39px);
      font-size: $font-size-lg;
    }
  }
}
</style>
